<!-- confirm-reservation.component.html -->
<main class="confirm-reservation-wrapper">
  <!-- Loading overlay -->
  @if (isLoading) {
  <div
    class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-overlay"
  >
    <div class="spinner-border" role="status" aria-hidden="true"></div>
  </div>
  }

  <!-- Main card (only when result is not decided) -->
  @if (success === null) {
  <c-card class="modern-card card-max mx-auto shadow-sm">
    <!-- Header -->
    <c-card-header
      class="header-bar d-flex justify-content-center align-items-center"
    >
      <div class="d-flex align-items-center gap-3">
        <span class="icon-bubble">
          <svg
            [cIcon]="icons.cilCheckCircle"
            size="xl"
            class="text-success"
          ></svg>
        </span>
        <h5 class="mb-0 fw-semibold text-dark">
          {{ "CONFIRM_PAGE.TITLE" | translate }}
        </h5>
      </div>
    </c-card-header>
    <!-- Body -->
    <c-card-body class="body-content text-center">
      <p class="reservation-info mt-2 mb-1 text-muted">
        {{ "CONFIRM_PAGE.RESERVATION_NUMBER" | translate }}
      </p>
      <p class="mb-0">
        <span class="id-badge">{{ reservationId }}</span>
      </p>
      <!-- Desktop/Tablet primary action -->
      <div class="text-center mt-4 d-none d-md-block">
        <button
          cButton
          class="btn--primary-gradient rounded-pill px-5"
          type="button"
          (click)="onConfirmClick()"
          [disabled]="isLoading || success === true"
        >
          @if (!isLoading) {
          {{ "CONFIRM_PAGE.BUTTON_TEXT" | translate }}
          } @if (isLoading) {
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="ms-2">{{
            "CONFIRM_PAGE.LOADING_TEXT" | translate
          }}</span>
          }
        </button>
      </div>
      <!-- Sticky bottom action for phones -->
      <div class="sticky-actions d-md-none">
        <button
          cButton
          class="btn--primary-gradient w-100 rounded-pill py-3"
          type="button"
          (click)="onConfirmClick()"
          [disabled]="isLoading || success === true"
        >
          @if (!isLoading) {
          {{ "CONFIRM_PAGE.BUTTON_TEXT" | translate }}
          } @if (isLoading) {
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="ms-2">{{
            "CONFIRM_PAGE.LOADING_TEXT" | translate
          }}</span>
          }
        </button>
      </div>
    </c-card-body>
    <!-- Footer -->
    <c-card-footer class="footer-bar text-center">
      <div class="footer-content">
        <small class="text-muted d-block copyright">
          © 2024 Sagel. All rights reserved.
        </small>
        <small class="text-muted d-block contact">
          For inquiries:
          <a href="mailto:info&#64;sagel.ai" class="footer-email"
            >info&#64;sagel-ai.com</a
          >
        </small>
      </div>
    </c-card-footer>
  </c-card>
  }

  <!-- SUCCESS ALERT -->
  @if (success === true) {
  <c-alert
    color="success"
    class="result-alert shadow-sm border-0 text-center card-max mx-auto"
  >
    <button
      (click)="success = null"
      class="position-absolute top-0 end-0 m-2"
      cButtonClose
    ></button>
    <div class="alert-icon mb-2">
      <svg [cIcon]="icons.cilCheckCircle" size="xxl" class="text-success"></svg>
    </div>
    <h4 cAlertHeading class="fw-bold mb-2">
      {{ "CONFIRM_PAGE.ALERT_SUCCESS_TITLE" | translate }}
    </h4>
    <p class="mb-0 text-muted">
      {{ "CONFIRM_PAGE.SUCCESS_MESSAGE" | translate }}
    </p>
  </c-alert>
  }

  <!-- ERROR ALERT -->
  @if (success === false) {
  <c-alert
    color="danger"
    class="result-alert shadow-sm border-0 text-center card-max mx-auto"
  >
    <button
      (click)="success = null; errorMessage = null"
      class="position-absolute top-0 end-0 m-2"
      cButtonClose
    ></button>
    <div class="alert-icon mb-2">
      <svg [cIcon]="icons.cilXCircle" size="xxl" class="text-danger"></svg>
    </div>
    <h4 cAlertHeading class="fw-bold mb-2">
      {{ "CONFIRM_PAGE.ALERT_ERROR_TITLE" | translate }}
    </h4>
    <p class="mb-0 text-muted">
      {{ errorMessage || ("CONFIRM_PAGE.ERROR_MESSAGE" | translate) }}
    </p>
  </c-alert>
  }

  <!-- Confirm Modal -->
  @if (showConfirmModal) {
  <div class="confirm-backdrop">
    <div
      class="confirm-modal modern-card p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirmModalTitle"
    >
      <h6 id="confirmModalTitle" class="fw-semibold mb-3 text-center">
        {{ "CONFIRM_PAGE.TITLE" | translate }}
      </h6>
      <p class="mb-4 text-center">
        {{ "CONFIRM_PAGE.CONFIRM_TEXT" | translate }}
      </p>
      <div class="d-flex justify-content-center gap-2">
        <button
          cButton
          class="btn btn-success rounded-pill px-4"
          (click)="confirmReservationDecision(true)"
        >
          {{ "CONFIRM_PAGE.CONFIRM_YES" | translate }}
        </button>
        <button
          cButton
          class="btn btn-secondary rounded-pill px-4"
          (click)="confirmReservationDecision(false)"
        >
          {{ "CONFIRM_PAGE.CONFIRM_NO" | translate }}
        </button>
      </div>
    </div>
  </div>
  }
</main>
